import { motion } from 'framer-motion';

interface FloatingActionButtonProps {
  onClick: () => void;
  position: 'bottom-left' | 'bottom-right';
  className: string;
  icon: string;
  title: string;
  delay?: number;
  children?: React.ReactNode;
}

const FloatingActionButton = ({ onClick, position, className, icon, title, delay = 0.5, children }: FloatingActionButtonProps) => {
  const positionClasses = position === 'bottom-left' ? 'bottom-6 left-6' : 'bottom-6 right-6';

  return (
    <motion.button
      onClick={onClick}
      className={`fixed ${positionClasses} z-40 flex items-center justify-center gap-3 font-medium text-white rounded-full shadow-lg transition-all duration-300 cursor-pointer ${className}`}
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ duration: 0.5, delay }}
      whileHover={{ scale: 1.1, boxShadow: "0 8px 25px rgba(0,0,0,0.25)" }}
      whileTap={{ scale: 0.9 }}
      title={title}
    >
      <motion.i
        className={`${icon} text-2xl`}
        animate={{ scale: [1, 1.2, 1] }}
        transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
      />
      {children}
    </motion.button>
  );
};

export default FloatingActionButton;